import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const FOUNDER = "/assets/pankaj-sharma.png";

export const Leadership = () => {
  return (
    <section data-testid="leadership-section" className="relative py-24 md:py-32 bg-navy overflow-hidden">
      <div className="absolute bottom-0 left-1/4 w-[500px] h-[500px] rounded-full bg-brand-orange/10 blur-[160px]" />
      <div className="container-x relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-5"
          >
            <div className="relative max-w-sm mx-auto lg:mx-0">
              <div className="absolute -inset-3 rounded-[2rem] bg-gradient-to-br from-brand-orange/40 to-transparent blur-lg" />
              <div className="relative rounded-[2rem] overflow-hidden border border-white/15 shadow-2xl shadow-black/50">
                <img src={FOUNDER} alt="Pankaj Sharma, Founder and CEO of ATS IT Solutions." className="w-full h-auto" />
                <div className="absolute inset-0 ring-1 ring-inset ring-white/10 rounded-[2rem]" />
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="lg:col-span-7"
          >
            <span className="overline">Leadership</span>
            <h2 className="font-head text-3xl md:text-4xl font-semibold text-white mt-4">Pankaj Sharma</h2>
            <p className="text-brand-orange font-medium mt-1">Founder &amp; CEO — ATS IT Solutions</p>
            <p className="mt-6 text-lg text-slate-300 leading-relaxed max-w-2xl">
              16+ years in enterprise technology, AI, and cloud — having worked with organizations including IBM, Mastercard, and EY. Pankaj leads ATS with a simple belief: technology should create measurable value, not just solve technical problems.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-4">
              <Link to="/about" data-testid="leadership-read-more" className="btn-primary">
                Read Full Story <ArrowRight size={16} />
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Leadership;
